module.exports = __webpack_public_path__ + "img/logo_17.8c4fd8f3.png";